import React from "react";
import { InputFocusBlue, shadowNormal } from "../../../Utils/Constant";

const DebateTextArea = ({
  maxLength,
  placeholder,
  label,
  value = "",
  handleChange,
  handlePaste,
  onFocus,
  onBlur,
  className,
  readOnly = false,
  id,
}) => {
  const wordCount = (value) => {
    // Split by spaces and newlines, and filter out empty strings
    return value?.trim()?.split(/\s+/)?.filter(Boolean)?.length;
  };

  const count = wordCount(value);
  return (
    <div className="relative w-full space-y-2">
      <label htmlFor={id} className="text-lg font-semibold">
        {label}
      </label>
      <textarea
        id={id}
        className={`resize-y w-full block flex-1 relative overflow-auto border-2 align-middle border-debatePalette-buttonBorder focus:outline-none rounded-md p-2 ${shadowNormal} focus:border-debatePalette-shadow ${InputFocusBlue} ${className}`}
        rows={3}
        value={value}
        onChange={handleChange}
        onPaste={handlePaste}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        readOnly={readOnly}
      />
      <span className="absolute bottom-0 right-3">
        {`${maxLength - (value ? count : 0)}`}
      </span>
    </div>
  );
};
export default DebateTextArea;
